import $ from "jquery";

(function () {
  // ? This is used for the share modal as well

  // Modal Buttons
  const modalButtons = Array.from(
    document.querySelectorAll("a[data-launch-modal]")
  );
  if (modalButtons.length) {
    modalButtons.forEach(function (btn) {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const guid = e.target.closest("[data-launch-modal]").dataset
          .launchModal;
        popModal(guid);
      });
    });
  }

  // Payment forms
  const paymentFormField = document.querySelector(
    ".ginput_container_creditcard"
  );
  if (paymentFormField) {
    const paymentForm = paymentFormField.closest("form");

    // Pop modal after 7sec
    $(paymentForm).on("submit", function () {
      const guid = "form-failure-modal";
      setTimeout(() => {
        popModal(guid);
      }, 7000);
    });
  }

  const modalCloseButtons = Array.from(
    document.querySelectorAll(".embedded-page-modal__close")
  );
  if (modalCloseButtons.length) {
    modalCloseButtons.forEach(function (btn) {
      btn.addEventListener("click", (e) => {
        const guid = e.target.closest("[data-modal-id]").dataset.modalId;
        closeModal(guid);
      });
    });
  }
})();

// Pop modal by guid
export function popModal(guid) {
  document.querySelector(
    `.embedded-page-modal__content[data-modal-id="${guid}"]`
  ).style.display = "block";
  const modal = document.querySelector(
    `.embedded-page-modal[data-modal-id="${guid}"]`
  );
  modal.classList.add("embedded-page-modal--untransitioned");
  requestAnimationFrame(() => {
    modal.classList.replace(
      "embedded-page-modal--untransitioned",
      "embedded-page-modal--transitioned"
    );
  });
}

// Close modal
function closeModal(guid) {
  const modal = document.querySelector(
    `.embedded-page-modal[data-modal-id="${guid}"]`
  );
  modal.classList.add("embedded-page-modal--untransitioned");
  modal.classList.replace(
    "embedded-page-modal--transitioned",
    "embedded-page-modal--untransitioned"
  );
  setTimeout(() => {
    modal.classList.remove("embedded-page-modal--untransitioned");
  }, 350);
}
